const DEFAULT_MARGIN = [0, 10, 0, 10];
const DEFAULT_LINE_WIDTH = 1;
const DEFAULT_LINE_COLOR = '000000';

export function isHorizontalRule(line: string): boolean {
    return line === '---';
}

export function createHorizontalRuleObject(): any {
    return { 
        text: '', 
        options: { 
            line: { 
                width: DEFAULT_LINE_WIDTH, 
                color: DEFAULT_LINE_COLOR
            }, 
            margin: DEFAULT_MARGIN 
        } 
    };
}
